"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var enquiryFormDataTransformer_1 = require("../service/enquiryFormDataTransformer");
var enquiryFormErrorTransformer_1 = require("../service/enquiryFormErrorTransformer");
var useEnquiryFormValidate = function (requiredFields, intl) {
    var _a = react_1.useState(true), hasErrors = _a[0], setHasErrors = _a[1];
    var _b = react_1.useState(null), asyncErrors = _b[0], setAsyncErrors = _b[1];
    var checkEmptyValues = react_1.useCallback(function (data) {
        var formattedData = enquiryFormDataTransformer_1.default.from(data);
        var requiredFormattedData = Object.keys(formattedData).reduce(function (acc, key) {
            if (requiredFields.includes(key)) {
                acc = __spreadArrays(acc, [formattedData[key]]);
            }
            return acc;
        }, []);
        var hasEmpty = requiredFormattedData.some(function (val) {
            if (typeof val === 'string') {
                return !val.trim();
            }
            return !val;
        }) || requiredFormattedData.length !== requiredFields.length;
        if (hasEmpty) {
            setHasErrors(hasEmpty);
        }
        return hasEmpty;
    }, [requiredFields]);
    var handleValidationErrors = react_1.useCallback(function (data) {
        var _a;
        var hasValidationErrors = ((_a = data.errors) === null || _a === void 0 ? void 0 : _a.length) > 0;
        setHasErrors(hasValidationErrors || checkEmptyValues(data.formData));
    }, [hasErrors, asyncErrors, requiredFields]);
    var handleAsyncValidationErrors = react_1.useCallback(function (error) {
        var err = enquiryFormErrorTransformer_1.default.from(error.response.data.message, intl);
        setAsyncErrors(err);
    }, [asyncErrors]);
    var resetAsyncErrors = react_1.useCallback(function () {
        setAsyncErrors(null);
    }, []);
    return {
        hasErrors: hasErrors,
        asyncErrors: asyncErrors,
        handleValidationErrors: handleValidationErrors,
        handleAsyncValidationErrors: handleAsyncValidationErrors,
        resetAsyncErrors: resetAsyncErrors,
        checkEmptyValues: checkEmptyValues,
    };
};
exports.default = useEnquiryFormValidate;
